import { Button, Typography } from "antd";
import FilterComponent from "components/Configuration/CommonComponents/FilterComponent";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { cglFormatDate } from "utils/functions";
import { getData } from "../../../../apiServices/common";
import AppContent from "../../../../common/AppContent";
import HandleNotification from "../../../../common/Notification";
import AppPageHeader from "../../../../common/PageHeader";
import ExtraContent from "../../../Configuration/CommonComponents/ExtraContent";
import SewingToFoldingTable from "./SewingToFoldingTable";

const SewingToFolding = (props) => {
  // Router
  const location = useLocation();
  const routerPath = location ? location.pathname : null;
  const navigate = useNavigate();

  // States
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [page, setPage] = useState(1);
  const [refresh, setRefresh] = useState(0);
  const [tableData, setTableData] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [filterValues, setFilterValues] = useState({});
  console.log("🚀 ~ SewingToFolding ~ filterValues:", filterValues);

  // Antd
  const { Title } = Typography;

  // Filter open/close status update in localStorage
  useEffect(() => {
    const filterStatus = localStorage.getItem("filter_status");
    const parsedFilterStatus = filterStatus ? JSON.parse(filterStatus) : {};

    if (showFilter) {
      parsedFilterStatus[routerPath] = true;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    } else {
      parsedFilterStatus[routerPath] = false;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    }
  }, [showFilter, routerPath, location]);

  const onFilterChange = (values) => {
    setFilterValues(values);
  };

  const fetchData = useCallback(
    async (filterValues) => {
      const query = `/api/digitalization/garment-received-from-sewing-list`;
      const bodyData = {
        page: page,
        per_page: filterValues?.per_page || 10,
        ...(filterValues?.line_id && { line_id: filterValues?.line_id }),
        ...(filterValues?.style_id && { style_id: filterValues?.style_id }),
        ...(filterValues?.sub_style_id && {
          sub_style_id: filterValues?.sub_style_id,
        }),
        ...(filterValues?.po_map_id && {
          po_map_id: filterValues?.po_map_id,
        }),
      };

      const response = await getData(query, false, bodyData);

      if (response && response?.data?.code === 200) {
        setTableData(response?.data?.data?.data);
        setPageSize(response?.data?.data?.per_page);
        setTotal(response?.data?.data?.total);
      } else {
        HandleNotification("error", "Error", "Something went wrong");
      }
    },
    [page],
  );

  useEffect(() => {
    const value = {
      ...filterValues,
      page: page,
    };
    fetchData(value);
  }, [refresh, page, pageSize, filterValues]);

  const onPageChange = (newPage) => {
    setPage(newPage);
  };

  const handleEdit = (event, record) => {
    navigate(`/digitalization/finishing/sewing-to-folding/edit/${record.id}`);
  };

  const tableColumns = [
    {
      title: "Entry Date",
      dataIndex: "entry_date",
      key: "entry_date",
      width: "120px",
      render: (row) => cglFormatDate(row),
    },
    {
      title: "Hour",
      dataIndex: "hour",
      key: "hour",
      width: "80px",
    },
    {
      title: "Line",
      dataIndex: ["line_info", "name"],
      key: "line",
      width: "100px",
    },
    {
      title: "Style",
      dataIndex: ["style_info", "style_no"],
      key: "style",
      width: "100px",
    },
    {
      title: "Sub Style",
      dataIndex: ["sub_style_info", "sub_style_no"],
      key: "sub_style",
      width: "120px",
    },
    {
      title: "Sales Contract",
      dataIndex: ["sales_contract_info", "reference_no"],
      key: "sales_contract",
      width: "150px",
    },
    {
      title: "Buying Office",
      dataIndex: ["buying_office_info", "name"],
      key: "buying_office",
      width: "150px",
    },
    {
      title: "Buyer",
      dataIndex: ["buyer_info", "name"],
      key: "buyer",
      width: "150px",
    },
    {
      title: "PO",
      dataIndex: ["po_map_info", "original_po"],
      key: "po",
      width: "120px",
    },
    {
      title: "Color",
      dataIndex: ["color_info", "name"],
      key: "color",
      width: "120px",
    },
    {
      title: "Size",
      dataIndex: ["size_info", "name"],
      key: "size",
      width: "80px",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      width: "100px",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "100px",
    },

    {
      title: "Action",
      key: "action",
      width: "15%",
      render: (_, record) => (
        <div>
          <Button
            style={{ marginLeft: 5 }}
            size="small"
            onClick={(event) => {
              handleEdit(event, record);
            }}
          // disabled={!hasPermission([USER_EDIT_PERMISSION])}
          >
            Edit
          </Button>
        </div>
      ),
    },
  ];
  const memoizedCustomFilter = useMemo(
    () => (
      <FilterComponent
        tableData={tableData}
        filterAPI={onFilterChange}
        filterName={"finishing-sewing-to-folding"}
        setShowFilter={setShowFilter}
        showFilter={showFilter}
      />
    ),
    [showFilter],
  );

  const header = (
    <AppPageHeader
      extra={
        <ExtraContent
          refresh={refresh}
          setRefresh={setRefresh}
          handleAddItemOpen={fetchData}
          hideAddButton={true}
          setShowFilter={setShowFilter}
          showFilter={showFilter}
        />
      }
      title={<Title level={5}>Finishing (Sewing to Folding)</Title>}
    />
  );
  const content = (
    <>
      {memoizedCustomFilter}
      <SewingToFoldingTable
        onChange={(newPage) => {
          onPageChange(newPage);
        }}
        total={total}
        current={page}
        defaultCurrent={page}
        pageSize={pageSize}
        dataSource={tableData}
        tableColumns={tableColumns}
        pagination={true}
      />
    </>
  );
  return (
    <>
      <AppContent header={header} content={content} />
    </>
  );
};

export default SewingToFolding;
